import { FC } from "react";
import { AudioBookCard } from "./AudioBookCard";
import { PrintBookCard } from "./PrintBookCard";
import { PrintCounterCard } from "./PrintCounterCard";
import { PrintTrackingCard } from "./PrintTrackingCard";

export const PDFGeneratedState: FC = () => {
  return (
    <>
      <div className="flex flex-col lg:flex-row space-y-6 lg:space-y-0 lg:space-x-6">
        <PrintBookCard />
        <AudioBookCard />
      </div>
      <div className="flex space-x-6">
        <PrintCounterCard />
      </div>
      <PrintTrackingCard />
    </>
  );
};
